import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

const SearchResultItem = (props) => {
  const { onClick, type, title, subtitle } = props

  return (
    <div
      className="search-list-item"
      onClick={onClick}
    >
      <span className="search-list-item__icon">
        <i className={cn({
          'ri-hotel-line': type === 'hotel',
          'ri-landscape-fill': type === 'group',
          'ri-map-pin-2-fill': type === 'city' || type === 'destination'
        })} />
      </span>
      <p className="search-list-item__text">
        <span className="title" dangerouslySetInnerHTML={{ __html: title }} />
        <span className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
      </p>
    </div>
  )
}

SearchResultItem.propTypes = {
  type: PropTypes.oneOf(['hotel', 'group', 'city', 'destination']).isRequired,
}

export default SearchResultItem
